import { Button, TextField, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';

const styles = {
  contentContainer: {
    backgroundColor: '#fff',
    borderRadius: 4,
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    '@media (max-height: 750px)': {
      maxHeight: 600,
      overflowY: 'auto'
    }
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  body: {
    padding: '40px 30px'
  },
  textField: {
    width: '100%'
  },
  marginTop20: {
    marginTop: 20
  },
  buttonConfirm: {
    width: '100%',
    fontSize: 14,
    fontWeight: 700
  },
  menuName: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 5
  },
  textNote: {
    color: '#808080',
    fontSize: 14,
    fontWeight: 400,
    padding: '8px 0'
  },
  btnResetAmount: {
    fontSize: 16,
    fontWeight: 400,
    color: '#2196F3',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left',
    justifyContent: 'unset'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    amountUpdated,
    setAmountUpdated,
    validAmountUpdated,
    amountUpdatedError,
    confirmUpdateAmount,
    gochiChoseUpdateAmount
  }) => {
    return (
      <>
        <div className={classes.contentContainer}>
          <div className={classes.body}>
            <Typography className={classes.title} variant="h6">
              金額修正
            </Typography>
            <div>
              <div>
                <Typography className={classes.menuName}>
                  コース名：
                  {gochiChoseUpdateAmount.menuName}
                </Typography>
                <RequiredButton />
                <div>
                  <TextField
                    required
                    label="教室振込額"
                    className={classes.textField}
                    margin="normal"
                    value={amountUpdated}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={e => {
                      setAmountUpdated(e.target.value.trim());
                    }}
                    onBlur={validAmountUpdated}
                  />
                </div>
                <ValidationText message={amountUpdatedError} />
                <div className={classes.textNote}>
                  クーポン利用者の損失を回避するために、減額のみ可能です。
                </div>
                <div>
                  <Button
                    className={classes.btnResetAmount}
                    onClick={() => {
                      setAmountUpdated(0);
                    }}
                  >
                    全額取消
                  </Button>
                </div>
              </div>
            </div>

            <div className={classes.marginTop20}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  confirmUpdateAmount();
                }}
                className={classes.buttonConfirm}
              >
                確認へ
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
